import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
import Link from './Link';
import SplitLink from './SplitLink';
var ColumnOfLinks = function ColumnOfLinks(_ref) {
  var links = _ref.links,
    title = _ref.title,
    setShowMobileMenu = _ref.setShowMobileMenu,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    className: "column-of-links-container"
  }, /*#__PURE__*/React.createElement("h3", {
    className: title ? 'column-of-links-title' : ''
  }, /*#__PURE__*/React.createElement(T, {
    source: title
  })), /*#__PURE__*/React.createElement("ul", {
    className: "column-of-links-list"
  }, links.map(function (link) {
    return /*#__PURE__*/React.createElement("li", {
      key: link.uniqueId || link.text,
      className: "column-of-links-item"
    }, link.icon ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: link.icon
    }) : null, link.isSplit ? /*#__PURE__*/React.createElement(SplitLink, {
      leftLink: link.parts[0],
      rightLink: link.parts[1],
      className: className,
      setShowMobileMenu: setShowMobileMenu
    }) : /*#__PURE__*/React.createElement(Link, {
      href: link.url,
      link: link,
      className: className,
      setShowMobileMenu: setShowMobileMenu
    }));
  })));
};
export default ColumnOfLinks;